








































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

import MediaValue from "@/interfaces/MediaValue";
import EntryItem from "@/components/EntryItem.vue";
import Entry from "@/models/Entry";
import { Brand, Company, Product } from "@/models";
import { AdcontrolProfile } from "@/models";

type TableDataUtility = {
  safeNumber: (val: number | string | null | undefined) => number;
  percentage: (num: number, denom: number) => number;
};

type MappedTableDataItem = {
  item: Entry;
  radioPercentage: number;
  tvPercentage: number;
  totalPercentage: number;
  total: number;
  radio: number;
  tv: number;
  tvTab: number;
  tvSponsor: number;
  radioTab: number;
  radioSponsor: number;
  tvTabPercentage: number;
  tvSponsorPercentage: number;
  radioTabPercentage: number;
  radioSponsorPercentage: number;
  vodPresence: boolean;
};

type TableDataTotals = {
  total: number;
  radio: number;
  tv: number;
  tvTab: number;
  tvSponsor: number;
  radioTab: number;
  radioSponsor: number;
};

@Component({
  components: {
    EntryItem,
  },
})
export default class SubEntryGroupingTable extends Vue {
  @Prop({ default: () => [] }) readonly items!: Array<Entry>;
  @Prop() readonly media!: MediaValue;
  @Prop({ default: 0 }) decimals!: number;
  @Prop({ default: false }) spotTypeDetail!: boolean;
  @Getter("profile")
  readonly profile!: AdcontrolProfile;

  loading = false;

  get columns() {
    const mediaColumns = [];
    if (this.media.radio) {
      mediaColumns.push({ label: "RADIO", id: "radio", singleCol: false });
    }
    if (this.media.tv) {
      mediaColumns.push({ label: "TV", id: "tv", singleCol: false });
    }
    return mediaColumns;
  }

  get hideNonVodIfProfileVodOnly(): boolean {
    if (this.profile?.mediaSourceKind == "msk_vod") {
      return true;
    }
    return false;
  }

  onEntryClick(item: Company | Brand | Product) {
    this.$router.push({
      name: "InvestorSummary",
      params: {
        type: item.type,
        id: item.id,
      },
      query: {
        radio: this.media.radio ? "1" : "0",
        tv: this.media.tv ? "1" : "0",
      },
    });
  }

  get showVodCol(): boolean {
    return this.items.some((item) => item.vodPresence);
  }

  get tableData(): { items: MappedTableDataItem[]; totals: TableDataTotals } {
    const utility: TableDataUtility = {
      safeNumber: (val: number | string | null | undefined): number => {
        const parsed = parseFloat(`${val ?? 0}`);
        return isNaN(parsed) ? 0 : parseFloat(parsed.toFixed(2));
      },
      percentage: (num: number, denom: number): number =>
        denom === 0 ? 0 : Math.round((num / denom) * 100),
    };

    const totals: TableDataTotals = this.items.reduce<TableDataTotals>(
      (a, b: Entry) => {
        const tvCount = utility.safeNumber(b.tvCount ?? b.detectionsCount);
        const radioCount = utility.safeNumber(
          b.radioCount ?? b.detectionsCount
        );

        return {
          total: a.total + tvCount,
          radio: a.radio + radioCount,
          tv: a.tv + tvCount,
          tvTab: a.tvTab + utility.safeNumber(b.tvTabCount),
          tvSponsor: a.tvSponsor + utility.safeNumber(b.tvSponsorCount),
          radioTab: a.radioTab + utility.safeNumber(b.radioTabCount),
          radioSponsor:
            a.radioSponsor + utility.safeNumber(b.radioSponsorCount),
        };
      },
      {
        total: 0,
        radio: 0,
        tv: 0,
        tvTab: 0,
        tvSponsor: 0,
        radioTab: 0,
        radioSponsor: 0,
      }
    );

    const items: MappedTableDataItem[] = this.items.map(
      (o: Entry): MappedTableDataItem => {
        const tv = utility.safeNumber(o.tvCount ?? o.detectionsCount);
        const radio = utility.safeNumber(o.radioCount ?? o.detectionsCount);
        const total = utility.safeNumber(o.detectionsCount);
        const tvTab = utility.safeNumber(o.tvTabCount);
        const tvSponsor = utility.safeNumber(o.tvSponsorCount);
        const radioTab = utility.safeNumber(o.radioTabCount);
        const radioSponsor = utility.safeNumber(o.radioSponsorCount);

        return {
          item: o,
          tv: tv,
          total: total,
          radio: radio,
          tvTab: tvTab,
          radioTab: radioTab,
          tvSponsor: tvSponsor,
          radioSponsor: radioSponsor,
          radioPercentage: utility.percentage(radio, totals.radio),
          tvPercentage: utility.percentage(tv, totals.tv),
          totalPercentage: utility.percentage(total, totals.total),
          tvTabPercentage: utility.percentage(tvTab, tv || 1),
          tvSponsorPercentage: utility.percentage(tvSponsor, tv || 1),
          radioTabPercentage: utility.percentage(radioTab, radio || 1),
          radioSponsorPercentage: utility.percentage(radioSponsor, radio || 1),
          vodPresence: !!o.vodPresence,
        };
      }
    );
    return { items, totals };
  }
}
